var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wz-button',{attrs:{"variant":"primary","size":"xl"},on:{"click":_vm.onSsoSubmit}},[_vm._v("Acceder")])
}
var staticRenderFns = []

export { render, staticRenderFns }